// extracted by mini-css-extract-plugin
export default {"label":"ModeTheme_label__ozThT","input":"ModeTheme_input__TLUZu","sun":"ModeTheme_sun__8Twvr","moon":"ModeTheme_moon__eaZFE"};